import React from "react";

function DetailRow({ label, value }) {
  if (value === undefined || value === null || value === "") return null;
  return (
    <div className="flex gap-3">
      <div className="uppercase text-[10px] tracking-[0.25em] text-[color:var(--text-muted)] min-w-[140px]">{label}</div>
      <div className="text-[color:var(--primary)] break-all">{String(value)}</div>
    </div>
  );
}

export function OrderDetails({ o }) {
  return (
    <div data-testid={`order-details-${o.order_id}`} className="mt-5 pt-5 border-t hairline">
      <div className="uppercase text-[10px] tracking-[0.3em] mb-3" style={{color: "var(--accent-metal)"}}>Full order record</div>
      <div className="grid md:grid-cols-2 gap-x-6 gap-y-2 text-xs">
        <DetailRow label="Order ID" value={o.order_id}/>
        <DetailRow label="Type" value={o.type}/>
        <DetailRow label="Created" value={o.created_at && new Date(o.created_at).toLocaleString()}/>
        <DetailRow label="Updated" value={o.updated_at && new Date(o.updated_at).toLocaleString()}/>
        <DetailRow label="Customer" value={o.customer_name}/>
        <DetailRow label="Email" value={o.email}/>
        <DetailRow label="Phone" value={o.phone}/>
        <DetailRow label="Shipping" value={o.shipping_address}/>
        <DetailRow label="Material" value={o.material}/>
        <DetailRow label="Tier" value={o.tier}/>
        <DetailRow label="Quantity" value={o.quantity}/>
        <DetailRow label="Complexity" value={o.complexity}/>
        <DetailRow label="Desired deadline" value={o.desired_deadline}/>
        <DetailRow label="Rush" value={o.rush ? "Yes" : "No"}/>
        <DetailRow label="Military discount" value={o.military_discount ? (o.military_proof_submitted ? "Yes (proof received)" : "Yes (proof pending)") : "No"}/>
        <DetailRow label="Payment status" value={o.payment_status || "—"}/>
        <DetailRow label="Card on file" value={o.card_on_file ? "Yes" : "No"}/>
        <DetailRow label="Stripe payment method" value={o.stripe_payment_method_id || "—"}/>
        <DetailRow label="Stripe customer" value={o.stripe_customer_id || "—"}/>
        <DetailRow label="Last PI" value={o.last_payment_intent_id || "—"}/>
        <DetailRow label="Subtotal" value={o.amount_cents ? `$${(o.amount_cents/100).toFixed(2)}` : (o.amount ? `$${(o.amount/100).toFixed(2)}` : "—")}/>
        <DetailRow label="Rush fee" value={o.rush_fee ? `$${(o.rush_fee/100).toFixed(2)}` : "—"}/>
        <DetailRow label="Quote amount" value={o.quote_amount ? `$${(o.quote_amount/100).toFixed(2)}` : "—"}/>
        <DetailRow label="Quote after discount" value={o.quote_amount_after_discount ? `$${(o.quote_amount_after_discount/100).toFixed(2)}` : "—"}/>
        <DetailRow label="Military proof note" value={o.military_proof_note}/>
        <DetailRow label="Charge last error" value={o.charge_last_error}/>
        {o.design_data && (
          <div className="md:col-span-2 mt-2">
            <div className="uppercase text-[10px] tracking-[0.25em] text-[color:var(--text-muted)] mb-1">Design data</div>
            <pre className="text-[11px] bg-[color:var(--muted)] rounded p-3 overflow-x-auto border hairline">{JSON.stringify(o.design_data, null, 2)}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
